window.addEventListener('load', () => {
    //Viewport Height
    let viewportHeight = window.innerHeight;
    document.documentElement.style.setProperty('--viewport-height', viewportHeight + 'px');

    let headerTop = document.getElementById('header').offsetTop;
    document.documentElement.style.setProperty('--custom-header-offset', headerTop + 'px');

    let h = document.getElementById('header').getBoundingClientRect().top;
    document.documentElement.style.setProperty('--header-offset', h + 'px');
});

document.addEventListener('scroll', () => {
    let headerTop = document.querySelector('.header-section').offsetTop;
    document.documentElement.style.setProperty('--custom-header-offset', headerTop + 'px');
});